import { useTranslation } from 'react-i18next';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';

import {
  StyledImage,
  StyledSlide,
  StyledSwiper,
  StyledTextContainer,
} from '~/components/organisms/auth/AuthLayout/components/slider/styled';
import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

import 'swiper/css/pagination';

import slide1 from '../../assets/slide-1.png';
import slide2 from '../../assets/slide-2.png';
import slide3 from '../../assets/slide-3.png';

import 'swiper/css';

const SLIDES = [
  {
    image: slide1,
    title: 'signUp:slides:0:title',
    desc: 'signUp:slides:0:desc',
    mt: 0,
  },
  {
    image: slide2,
    title: 'signUp:slides:1:title',
    desc: 'signUp:slides:1:desc',
    mt: 20,
  },
  {
    image: slide3,
    title: 'signUp:slides:2:title',
    desc: 'signUp:slides:2:desc',
    mt: 85,
  },
];

const renderBullet = (index, className) => `<span class="${className}" ></span>`;

export const Slider = () => {
  const { t } = useTranslation();
  return (
    <StyledSwiper
      pagination={{ clickable: true, renderBullet }}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      modules={[Pagination, Autoplay, Navigation]}
    >
      {SLIDES.map((item, index) => (
        <SwiperSlide key={index}>
          <StyledSlide>
            <StyledImage src={item.image} alt={item.title} mt={item.mt} />
            <StyledTextContainer>
              <Text variant="h2" sx={{ color: COLORS.white, textAlign: 'center' }}>
                {t(item.title)}
              </Text>
              <Text variant="subheader" sx={{ color: COLORS.white, textAlign: 'center' }}>
                {t(item.desc)}
              </Text>
            </StyledTextContainer>
          </StyledSlide>
        </SwiperSlide>
      ))}
    </StyledSwiper>
  );
};
